export default __webpack_public_path__ + "static/media/football2.d26cbb8f.mp4";